__turbopack_context__.v({
  "chart": "oc2lyW_chart",
  "container": "oc2lyW_container",
});
